import React from 'react';
import { Box, Heading, Text, Link } from '@chakra-ui/react';
import { ChakraAuthContentWrapper } from 'app/components/Core';
import { externalLinks } from 'app/api.config';
import AppStoreBadge from 'resources/images/mobile-app-store-badge.svg';
import GooglePlayStoreBadge from 'resources/images/google-play-store-badge.svg';
import { useIsMobile } from 'app/utils/hooks';

const linkStyle = (image) => ({
  height: '40px !important',
  backgroundImage: `url(${image})`,
  backgroundRepeat: 'no-repeat',
  _hover: {
    transform: 'scale(1.02)',
  },
  _active: {
    transform: 'scale(0.99)',
  },
});

export const ConfirmAccountSuccess = () => {
  const isMobileView = useIsMobile(false);

  return (
    <ChakraAuthContentWrapper
      px={4}
      pt={isMobileView ? 32 : 0}
      centeredContainerProps={{ w: 375 }}
    >
      <Heading
        as="h4"
        fontSize="xl"
        lineHeight="29px"
        marginBottom={1}
        fontWeight={600}
      >
        Email verified
      </Heading>
      <Text
        color="textSubdued"
        fontSize="md"
        lineHeight="22px"
        textAlign="center"
      >
        To continue download Session Studio for your phone.
      </Text>
      <Box
        width={265}
        display="inline-flex"
        justifyContent="space-between"
        pt={6}
      >
        <Link
          width={120}
          borderRadius="7px"
          {...linkStyle(AppStoreBadge)}
          href={externalLinks.mobileApp.IOS_APP_LINK}
        />
        <Link
          width={135}
          borderRadius="5px"
          {...linkStyle(GooglePlayStoreBadge)}
          href={externalLinks.mobileApp.ANDROID_APP_LINK}
        />
      </Box>
    </ChakraAuthContentWrapper>
  );
};
